module.exports = __webpack_public_path__ + "img/app-icon-4.266a6583.svg";